import { ScopeItem } from "../../scopeTypes.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const UPSERT_SCOPE_ITEM = createAppSessionEventDefinition({
  type: "UPSERT_SCOPE_ITEM",
  payloadSchema: ScopeItem,
  logSafe: {
    name: false,
    displayValue: false,
    type: true,
    rawType: false,
    isHidden: true,
    dataFrameSchema: false,
  },
  create: (payload: ScopeItem) => payload,
  apply: ({ payload, state }) => {
    const warnings: string[] = [];

    const scopeItem = state.scopeItems[payload.name];

    if (scopeItem != null) {
      scopeItem.name = payload.name;
      scopeItem.displayValue = payload.displayValue;
      scopeItem.type = payload.type;
      scopeItem.rawType = payload.rawType;
      scopeItem.isHidden = payload.isHidden;
      scopeItem.dataFrameSchema = payload.dataFrameSchema;
    } else {
      state.scopeItems[payload.name] = payload;
    }

    return { warnings };
  },
});
